import { IFetchTemplatesAction, IFetchTemplatesActionPayload, IFetchTemplatesSuccessActionPayload } from './interface';

const actionTypePrefix = "TEMPLATES/";
export const templateActions = {
    FETCH_TEMPLATES: `${actionTypePrefix}FETCH_TEMPLATES`,
    FETCH_TEMPLATES_SUCCESS: `${actionTypePrefix}FETCH_TEMPLATES_SUCCESS`,
    FETCH_TEMPLATES_FAILED: `${actionTypePrefix}FETCH_TEMPLATES_FAILED`,
};
export const fetchTemplatesAction = (
    payload: IFetchTemplatesActionPayload
): IFetchTemplatesAction => {
    return {
        type: templateActions.FETCH_TEMPLATES,
        payload,
    };
};
export const fetchTemplateSuccessAction = (
    payload: IFetchTemplatesSuccessActionPayload
   
) => {
    return {
        type: templateActions.FETCH_TEMPLATES_SUCCESS,
        payload,
    };
};
export const fetchTemplateFailedAction = (payload: {
    error: string;
    pageNumber: number;
    category: string;
}) => {
    return {
        type: templateActions.FETCH_TEMPLATES_FAILED,
        payload,
    };
};
